import "../shared-components/ViewFragments/ProjectEspecialSingle/style.less";

import React from "react";
import { decodeHashUrl } from "../shared-components/Utils/Functions";
import { PageLayout } from "src/Components/Layout/web";
import { withApollo } from "../lib/apollo3";
import { withAuth } from "../lib/auth";
import { withContext } from "../lib/context";
import { withGlobalComponents } from "../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../shared-components/i18n";
import { ContactModalProvider } from "shared-components/Contexts/ContactModal/context";
import { ProjectSpecial } from "src/Components/ProjectSpecial/ProjectSpecial";
import { PropertyDataProvider } from "src/contexts/PropertyData/PropertyDataProvider";
import { fetchSearchResults } from "src/services/search";
import { usePropertyDetails } from "shared-components/ViewFragments/PropertyDetails/PropertyDetails.hook";

// ProjectEspecialSingle
const projectEspecialSingle = props => {
	const { data: dataFromGraphQL, loading } = usePropertyDetails({
		id: props.__PROJECT__ID__,
		mode: "project",
		inactiveSimilarInfo: props?.inactiveSimilarInfo,
	});

	const data = (!props.data && !dataFromGraphQL?.project?.active) ? dataFromGraphQL.project : props.data;

	if (loading) {
		return <div>Loading...</div>;
	}

	return (
		<PropertyDataProvider initialListing={data}>
			<ContactModalProvider>
				<ProjectSpecial {...props} data={data} />

				{/* <RTBhouse page={"offer"} data={props.__PROJECT__ID__} /> */}
			</ContactModalProvider>
		</PropertyDataProvider>
	);
};

projectEspecialSingle.getInitialProps = async function ({ apolloClient, req, res, query }) {
	let project = await decodeHashUrl(query.hashed);
	const { main_domain } = project.configs;
	const __PROJECT__ID__ = project.id;
	const payload = {
		rows: 1,
		params: {
			id: __PROJECT__ID__,
		},
		page: 1,
		source: 10,
	};

	const fetchResult = await fetchSearchResults(payload, main_domain)
	const data = fetchResult.searchFast.data[0];

	if(project.status === "deactivated") {
		data.active = false;
	}

	if (!data) {
		// Si data es undefined, redirige a 404
		if (res) {
			// res.statusCode = 404;
			return {
				__PROJECT__ID__,
				data: null,
			};
		} else {
			throw new Error("Data not found");
		}
	}

	return {
		__PROJECT__ID__,
		UrlToBack: query.location || -1,
		DummyContextInitialState: { count: 23 },
		ConfigContextInitialState: project?.configs,
		data,
	};
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(projectEspecialSingle))), {
		withDummyContext: false,
		withFiltersContext: true,
		withConfigContext: true,
		withThemeContext: true,
	})
);

